/**
 * SEO Phase 3 — GA4 analytics. Complete no-op when no measurement ID is
 * configured in CMS (settings.ga4_measurement_id). Zero side effects, zero
 * network requests when blank.
 *
 * Events only fire from genuine completed user actions — never on page
 * load, never on hover, never on render.
 */

let _measurementId = null;
let _ready = false;

/** Called once when settings resolve with a non-empty ga4_measurement_id. */
export function initAnalytics(measurementId) {
  if (!measurementId || typeof window === "undefined") return;
  if (_ready && _measurementId === measurementId) return; // already initialised
  _measurementId = measurementId;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
  window.gtag("js", new Date());
  // send_page_view: false — we send page_view manually on route change
  // so SPA navigations are tracked without double-counting the initial load.
  window.gtag("config", _measurementId, { send_page_view: false });
  _ready = true;
}

/** Track a page view (called on every React Router location change). */
export function trackPageView(path) {
  if (!_ready || !_measurementId) return;
  window.gtag("event", "page_view", { page_path: path });
}

/** Track a named conversion event. No-op when GA4 not configured. */
export function trackEvent(name, params = {}) {
  if (!_ready || !_measurementId) return;
  window.gtag("event", name, params);
}
